<template>
  <div>
    <v-dialog v-model="dialog" width="520" persistent>
      <v-card class="subscription-dialog">
        <div class="dialog-header">
          <div class="status-icon"><v-icon color="red darken-1" size="30">mdi-credit-card-off-outline</v-icon></div>
          <v-btn v-if="!forced" icon small class="close-button" aria-label="Close" @click="dismiss">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="dialog-content">
          <div class="dialog-eyebrow">ACCOUNT NOTICE</div>
          <div class="dialog-title">Your subscription is {{ isExpired ? "expired" : "canceled" }}</div>
          <div class="dialog-message">
            Your smplsale subscription is no longer active. Visit Account &amp; Billing to review your subscription, enter payment information, and restore service.
          </div>

          <div :class="['dismissal-box', { 'dismissal-box-forced': forced }]">
            <div class="dismissal-copy">
              <strong>{{ forced ? "Dismissal limit reached" : `Reminder ${reminderNumber} of 5` }}</strong>
              <span v-if="forced">This notice can no longer be closed. Continue to Account &amp; Billing to restore your subscription.</span>
              <span v-else>You may dismiss this notice {{ remainingDismissals }} more {{ remainingDismissals === 1 ? "time" : "times" }}. After the fifth dismissal, Account &amp; Billing will be required.</span>
            </div>
            <div class="dismissal-progress" aria-hidden="true">
              <span v-for="index in 5" :key="index" :class="{ used: index <= reminderNumber }"></span>
            </div>
          </div>

          <div class="notice-box">
            <v-icon small color="orange darken-2" class="mr-2">mdi-information-outline</v-icon>
            <span>Some paid features may become unavailable until the subscription is active again.</span>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-btn v-if="!forced" text rounded color="grey darken-1" @click="dismiss">Not now</v-btn>
          <v-spacer />
          <v-btn color="primary" rounded depressed @click="gotoAccount">
            Go to Account &amp; Billing
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      show: { type: Boolean, default: false },
      forced: { type: Boolean, default: false },
      dismissalCount: { type: Number, default: 0 },
      subscriptionStatus: { type: String, default: "canceled" },
    },
    data () {
      return {
        dialog: false,
      }
    },
    computed: {
      reminderNumber() {
        return this.forced ? 5 : Math.min(this.dismissalCount + 1, 5)
      },
      remainingDismissals() {
        return Math.max(5 - this.dismissalCount, 0)
      },
      isExpired() {
        return this.subscriptionStatus === 'incomplete_expired'
      },
    },
    methods: {
      dismiss() {
        if (this.forced) return
        this.dialog = false
        this.$emit('dismissed')
      },
      gotoAccount() {
        this.$emit('gotoAccount')
      }
    },
    watch: {
      show(val) {
        this.dialog = val
      }
    }
  }
</script>

<style scoped>
.subscription-dialog{border-radius:22px!important;overflow:hidden}.dialog-header{padding:22px 22px 0;display:flex;align-items:flex-start;justify-content:space-between}.status-icon{width:58px;height:58px;border-radius:18px;background:#fff1f2;display:flex;align-items:center;justify-content:center}.close-button{margin-top:-5px;margin-right:-5px}.dialog-content{padding:18px 24px 22px!important}.dialog-eyebrow{font-size:10px;font-weight:800;letter-spacing:.14em;color:#be123c}.dialog-title{font-size:23px;font-weight:800;color:#0f172a;margin-top:5px}.dialog-message{font-size:14px;line-height:1.6;color:#475569;margin-top:9px}.dismissal-box{margin-top:17px;padding:13px 14px;border-radius:14px;background:#f8fafc;border:1px solid #e2e8f0}.dismissal-box-forced{background:#fff1f2;border-color:#fecdd3}.dismissal-copy{display:flex;flex-direction:column}.dismissal-copy strong{font-size:12px;color:#334155}.dismissal-box-forced .dismissal-copy strong{color:#be123c}.dismissal-copy span{font-size:11px;line-height:1.45;color:#64748b;margin-top:3px}.dismissal-progress{display:grid;grid-template-columns:repeat(5,1fr);gap:5px;margin-top:10px}.dismissal-progress span{height:4px;border-radius:4px;background:#e2e8f0}.dismissal-progress span.used{background:#f43f5e}.notice-box{margin-top:12px;padding:12px 14px;border-radius:14px;background:#fff7ed;color:#9a3412;font-size:12px;display:flex;align-items:flex-start;line-height:1.45}.dialog-actions{padding:14px 20px!important;border-top:1px solid #e2e8f0;background:#f8fafc}@media(max-width:500px){.dialog-title{font-size:20px}.dialog-actions{align-items:stretch;flex-direction:column-reverse}.dialog-actions .v-btn{width:100%;margin:0!important}.dialog-actions .spacer{display:none}}
</style>
